import { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { defaultTemplateListingSelector, getOnboardSelectTemplate } from '../boardTemplatePickerSelectors';
import { boardTemplatePickerContext } from '../context/boardTemplatePickerContext';

export default ({
    beforeSelectTemplate,
    shouldAutoSelectTemplate = true,
}: { beforeSelectTemplate?: () => void; shouldAutoSelectTemplate?: boolean } = {}) => {
    const { selectTemplate } = useContext(boardTemplatePickerContext);

    const defaultTemplateListing = useSelector(defaultTemplateListingSelector);
    const onboardingSelectTemplateId = useSelector(getOnboardSelectTemplate);

    useEffect(() => {
        if (!shouldAutoSelectTemplate) return;
        if (!onboardingSelectTemplateId) return;

        const selectTemplateIdExists = defaultTemplateListing.find((template) => {
            return template.id === onboardingSelectTemplateId;
        });

        if (selectTemplateIdExists) {
            beforeSelectTemplate?.();
            selectTemplate(onboardingSelectTemplateId);
        }
    }, [defaultTemplateListing, onboardingSelectTemplateId, shouldAutoSelectTemplate]);

    return onboardingSelectTemplateId;
};
